<template>
    <div class="container wrap">
        <div class="row">
            <div class="p-0 col-md-1 col-sm-1 col-2 ">
                <div class="wrap-heart">
                    <i class="icon-heart yellow"></i>
                </div>
            </div>
            <div class="pr-0 col-md-9 col-sm-9 col-10">
                <p v-html="cmsCovid.list"></p>
            </div>
            <div class="p-0 col-md-2 col-sm-2 col-2 d-none d-sm-block">
                <a :href="viewMoreUrl" title="ver detalhes" target="_blank">Ver detalhes</a>
            </div>
        </div>
        <div class="row">
            <div class="col-2 d-block d-sm-none"></div>
            <div class="col-10 d-block d-sm-none">
                <a :href="viewMoreUrl" title="ver detalhes" target="_blank">Ver detalhes</a>
            </div>
        </div>
    </div>
</template>

<script>
import cmsCovid from './../../cms/cms-covid'

export default {
  name: 'CovidList',
  data: function () {
    return {
      cmsCovid,
      viewMoreUrl: 'https://www.mobly.com.br/auto-atendimento/'
    }
  }
}
</script>

<style scoped lang="scss">
    $grey: #999999;
    .wrap {
        background: #FBEEC1;
        border-radius: 4px;
        margin: 8px 0;
        .wrap-heart {
            position: relative;
            top: 12px;
            left: 15px;
        }
        p {
            color: $grey;
            font-weight: 600;
            font-size: 14px;
            padding: 7px 0;
            margin-bottom: 0;
            line-height: 18px;
        }
        a {
            font-size: 12px;
            position: relative;
            top: 12px;
            text-decoration: underline;
        }
    }
    @media (max-width: 1200px) {
        .wrap {
            p {
                font-size: 12px;
            }
            a {
                top: 0;
            }
        }
    }
    @media (max-width: 991px) {
        .wrap {
            .wrap-heart {
                top: 3px;
            }
            p {
                font-size: 14px;
            }
            a {
                top: 2px;
            }
        }
    }
    @media (max-width: 766px) {
        .wrap {
            .wrap-heart {
                top: 10px;
            }
            a {
                top: 10px;
            }
        }
    }
    @media (max-width: 576px) {
        .wrap {
            .wrap-heart {
                top: 6px;
                left: 39px;
                .icon-heart.yellow{
                    font-size: 30px;
                }
            }
            a {
                top: -7px;
            }
        }
    }
    @media (max-width: 425px) {
        .wrap {
            .wrap-heart {
                position: relative;
                top: 8px;
                left: 15px;
            }
            a {
                left: 0;
                top: -7px;
            }
        }
    }
</style>
